import List from './list/ReportTypeListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})